import React from 'react';
import {Link} from 'react-router';
import './TroubleLoggingIn.scss';
import chevLeft from '../../assets/images/chev-left-royal.svg';
import withFeatureFlags from "../FeatureFlags/withFeatureFlags";
import chevRight from "../../assets/images/chev-right-royal.svg";
import bottomLeftCornerImg from "../../assets/images/Stripes Light Bottom Left.svg"
import TopRightCornerImg from "../../assets/images/Stripes Light Top Right.svg"
import './login.scss';
import CommonContainerStrips from '../Session/CommonContainerStrips.jsx';
/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */

const TroubleLoggingIn = (/** @type {WithFeatureFlagsProps} */ props) => {
    
    return (
        <CommonContainerStrips propData={{ bottomLeftImg: bottomLeftCornerImg, topRightImg: TopRightCornerImg, children: (
                <div className="troubleLoggingIn__frame3423">
                    <div className="troubleLoggingIn__login2">
                        <Link to="/login" className="login__link login__link--back loginP3__backButton"><img
                            src={chevLeft}/>Back to
                            login</Link>
                        <div className="troubleLoggingIn__havingTroubleDiv">
                            <label className="troubleLoggingIn__havingTroubleTxt">Having trouble logging in?</label>
                        </div>
                        <div className="troubleLoggingIn__frame3578">
                            <div className="troubleLoggingIn__frame3578_1">
                                <a href="/forgot-password" className="troubleLoggingIn__lblForgotPassword">Forgot your
                                    password?</a>
                                <img loading="lazy" src={chevRight} alt=""
                                     className="troubleLoggingIn__redirectButtonClass"/>
                            </div>
                            <div className="troubleLoggingIn__line"></div>
                            <div className="troubleLoggingIn__frame3579">
                                <a href="/forgot-email" className="troubleLoggingIn__lblForgotEmail">Forgot your email?</a>
                                <img loading="lazy" src={chevRight} alt=""
                                     className="troubleLoggingIn__redirectButtonClass"/>
                            </div>
                            <div className="troubleLoggingIn__frame39937">
                                <div className="troubleLoggingIn__line"></div>
                                <div className="troubleLoggingIn__frame3580">
                                    <label className="troubleLoggingIn__lblOtherWord">For anything else, please speak to our
                                        live chat
                                        team. Available weekdays between 08:00-20:00, excluding UK bank holidays.</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) }} />
    )
        ;
}

export default withFeatureFlags(TroubleLoggingIn);
